import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { cancelBid } from '../../services/sellerQuote'
import { onGetQuoteSummaryThunk } from '../QuoteBasicInformation/QuoteBasicInformation.actions'

export const CANCEL_BID_SHOW_DIALOG_SUCCESS = 'CANCEL_BID_SHOW_DIALOG_SUCCESS'
export const onCancelBidShowDialogSuccess = makeActionCreator(CANCEL_BID_SHOW_DIALOG_SUCCESS, 'payload')

export const CANCEL_BID_HIDE_DIALOG_SUCCESS = 'CANCEL_BID_HIDE_DIALOG_SUCCESS'
export const onCancelBidHideDialogSuccess = makeActionCreator(CANCEL_BID_HIDE_DIALOG_SUCCESS)

export const CANCEL_BID = 'CANCEL_BID'
export const CANCEL_BID_ERROR = 'CANCEL_BID_ERROR'
export const CANCEL_BID_SUCCESS = 'CANCEL_BID_SUCCESS'
export const onCancelBid = makeActionCreator(CANCEL_BID)
export const onCancelBidError = makeActionCreator(CANCEL_BID_ERROR, 'payload')
export const onCancelBidSuccess = makeActionCreator(CANCEL_BID_SUCCESS, 'payload')
export const onCancelBidThunk = payload => async dispatch => {
  dispatch(onCancelBid())
  const { quoteId, ipUsuario, bidId } = payload

  try {
    await cancelBid({ quoteId, ipUsuario, bidId })
    return batch(() => {
      dispatch(onCancelBidSuccess())
      dispatch(onGetQuoteSummaryThunk({ quoteId }))
    })
  } catch (error) {
    if (error.code === 400) {
      const err = error.originalError.response.data.errores.map(error => ({
        code: error.codigo,
        description: error.descripcion
      }))

      return dispatch(onCancelBidError({ error: err }))
    }

    return dispatch(onCancelBidError({ error: {} }))
  }
}
